import { faCreditCard } from "@fortawesome/pro-regular-svg-icons"
import { Divider, Typography } from "@mui/material"
import { Elements } from "@stripe/react-stripe-js"
import { translate } from "app/language/service"
import { getLocale } from "app/language/tools/common"
import { IRootState } from "app/model"
import { CURRENCIES } from "currency/model"
import { PageLoading } from "page/components/PageLoading"
import { IPayment, IPaymentInfo } from "payment/model"
import { paymentRPO } from "payment/repository"
import { getStripe } from "payment/tools/stripe"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { Popup } from "ui/components/Popup"
import { isPhoneScreen } from "ui/tools/responsive"
import { isDarkThemeActive } from "ui/tools/theme"
import { PaymentForm } from "./PaymentForm"
import { PaymentInfo } from "./PaymentInfo"

// https://stripe.com/docs/payments/quickstart

// BUG couleur planning

interface IPaymentPopupProps {
  amount: number
  currency: CURRENCIES
  onClose(): any
  onSuccess(payment: IPayment): any
}

interface IPaymentPopupConnectProps {
  isPhone: boolean
}

export const PaymentPopupFn = ({
  amount,
  currency,
  isPhone,
  onClose,
  onSuccess
}: IPaymentPopupProps & IPaymentPopupConnectProps) => {
  const [paymentInfo, setPaymentInfo] = useState<null | IPaymentInfo>(null)
  const [isProcessingPayment, setIsProcessingPayment] = useState(false)
  const [hasError, setHasError] = useState(false)
  useEffect(() => {
    // create PaymentIntent as soon as the page loads
    paymentRPO
      .initiatePayment(amount)
      .then(fetchedPaymentInfo => setPaymentInfo(fetchedPaymentInfo))
      .catch(error => {
        console.error(error)
        setHasError(true)
      })
  }, [])
  return (
    <Popup
      icon={faCreditCard}
      id="payment-popup"
      displayCloseIcon={!isProcessingPayment}
      title={translate("label.proceed.to.payment")}
      onClose={() => {
        if (isProcessingPayment) {
          return
        }
        onClose()
      }}
      minWidth={isPhone ? "calc(100% - 2rem)" : undefined}
      maxWidth={isPhone ? "calc(100% - 2rem)" : undefined}>
      {hasError ? (
        <Typography color="error">{translate("label.unexpected.error")}</Typography>
      ) : !paymentInfo ? (
        <PageLoading title={translate("label.loading.data")} noMargin />
      ) : (
        <>
          <Divider flexItem sx={{ mb: "1rem" }} />
          <FlexBox wrap={isPhone} gap ai="start">
            <PaymentInfo paymentInfo={paymentInfo} />
            <Divider orientation="vertical" flexItem />
            <Elements
              options={{
                clientSecret: paymentInfo.clientSecret,
                appearance: {
                  theme: isDarkThemeActive() ? "night" : "stripe"
                },
                locale: getLocale(),
                loader: "always"
              }}
              stripe={getStripe()}>
              <PaymentForm
                isProcessingPayment={isProcessingPayment}
                setIsProcessingPayment={setIsProcessingPayment}
                onClose={() => onClose()}
                onSuccess={payment => {
                  payment.amount = amount
                  payment.agency_currency = currency
                  payment.tax = paymentInfo.tax
                  payment.total = paymentInfo.total
                  onSuccess(payment)
                }}
              />
            </Elements>
          </FlexBox>
        </>
      )}
    </Popup>
  )
}

export const PaymentPopup = connect(
  (state: IRootState): IPaymentPopupConnectProps => ({
    isPhone: isPhoneScreen(state)
  })
)(PaymentPopupFn)
